import { Component, Input } from '@angular/core';
import { UtilityService } from 'src/app/_services/utility.service';

@Component({
  selector: 'app-monitoring-incremental-delta-card',
  templateUrl: './monitoring-incremental-delta-card.component.html',
  styleUrls: ['./monitoring-incremental-delta-card.component.css']
})
export class MonitoringIncrementalDeltaCardComponent {
  @Input() userMonitoring: any;

  constructor(public utilityService: UtilityService) {}
}
